// extracted by mini-css-extract-plugin
export var typingIndicator = "_re-0";